export function DashboardSkeleton () {
  return (
    <div className="gateway-dashboard" aria-label="Loading payment overview">
      <div className="gateway-hero gateway-skeleton-block" />
      <div className="gateway-stat-grid">
        {[0, 1, 2, 3].map((item) => <div className="gateway-stat-card gateway-skeleton-block" key={item} />)}
      </div>
      <div className="gateway-chart-grid">
        <div className="gateway-panel gateway-skeleton-block gateway-skeleton-chart" />
        <div className="gateway-panel gateway-skeleton-block gateway-skeleton-chart" />
      </div>
    </div>
  )
}